<div class="checklist-run-container">
  <div
    *ngIf="isLoading()"
    class="loading-container"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <p-progressSpinner aria-hidden="true"></p-progressSpinner>
    <span class="sr-only">Caricamento checklist in corso</span>
  </div>

  <main
    *ngIf="!isLoading() && checklist()"
    class="checklist-content"
    role="main"
    aria-labelledby="checklist-title"
  >
    <!-- WCAG 2.4.6: H1 as main heading -->
    <div class="checklist-header">
      <h1 id="checklist-title">{{ checklist().name }}</h1>
      <p-tag [value]="checklist().type" severity="info"></p-tag>
    </div>

    <section class="file-requests-section" aria-labelledby="file-requests-heading">
      <h2 id="file-requests-heading">Documenti Richiesti</h2>

      <div
        *ngIf="!checklist().fileUploadRequests || checklist().fileUploadRequests.length === 0"
        class="no-items"
        role="status"
        aria-live="polite"
      >
        Nessun documento richiesto
      </div>
      <div role="list" aria-label="Elenco documenti da caricare">
        <div
          *ngFor="let item of checklist().fileUploadRequests; let i = index"
          class="file-request-card"
          role="listitem"
          [attr.aria-labelledby]="'file-item-text-' + i"
        >
          <div class="request-header">
            <div class="request-left">
              <span class="request-position" aria-hidden="true">{{ item.position }}</span>
              <div class="request-content">
                <span class="request-text" [attr.id]="'file-item-text-' + i">{{ item.text }}</span>
                
                <!-- WCAG 3.3.2: Clear instructions for file upload -->
                <p class="upload-instructions" [attr.id]="'upload-help-' + i">
                  <span class="text-sm text-600">
                    <i class="pi pi-info-circle" aria-hidden="true"></i>
                    Formati supportati: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, JPG, PNG • Max 10 MB
                  </span>
                </p>
              </div>
            </div>

            <div class="request-right">
              <p-fileupload
                mode="basic"
                chooseLabel="Sfoglia"
                [auto]="false"
                [customUpload]="true"
                [showUploadButton]="false"
                [showCancelButton]="false"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png"
                [maxFileSize]="10485760"
                (onSelect)="onFileSelected($event, item, i)"
                [attr.id]="'file-upload-' + i"
                [attr.aria-labelledby]="'file-item-text-' + i"
                [attr.aria-describedby]="'upload-help-' + i"
              ></p-fileupload>
            </div>
          </div>

          <div *ngIf="getSelectedFileName(item, i)" class="selected-file">
            <i class="pi pi-check-circle text-green-500" aria-hidden="true"></i>
            File selezionato: {{ getSelectedFileName(item, i) }}
          </div>
        </div>
      </div>
    </section>

    <div class="action-buttons">
      <p-button
        label="Salva"
        icon="pi pi-save"
        severity="primary"
        [disabled]="!isSaveEnabled()"
        (onClick)="saveChecklist()"
        [attr.aria-label]="isSaveEnabled() ? 'Salva file selezionati' : 'Salva disabilitato: seleziona almeno un file'"
      ></p-button>
    </div>
  </main>

  <!-- WCAG 4.1.3: Toast with ARIA attributes -->
  <p-toast role="status" aria-live="polite" aria-atomic="true"></p-toast>
</div>
